import { StyleSheet } from 'react-native'

export const themedSectionListStyles = StyleSheet.create({
	viewHasSubtitle: {
		marginBottom: 0
	}
})
